import ReviewStatus from "@/views/ReviewView/ReviewStatus.vue";
import ShowReview from "@/views/ReviewView/ShowReview.vue";
import EditReview from "@/views/ReviewView/EditReview.vue";
import CompletedReview from "@/views/ReviewView/CompletedReview.vue";

import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

const reviewsMenu = {
  path: "/reviews",
  component: DashboardLayout,
  name: "Reviews",
  children: [
    {
      path: "status",
      name: "review-status",
      component: ReviewStatus,
      meta: { requiresAuth: true, requiredRoles: ["reviewer"], title: "심사 관리 > 심사 현황" },
    },
    {
      path: "done",
      name: "review-done",
      component: CompletedReview,
      meta: { requiresAuth: true, requiredRoles: ["reviewer"], title: "심사 관리 > 완료" },
    },
    {
      path: "detail/:idx",
      name: "review-detail",
      component: ShowReview,
      props: true,
      meta: { requiresAuth: true, requiredRoles: ["reviewer"], title: "심사 관리 > 심사 내용 조회" },
    },
    {
      path: "edit/:idx",
      name: "review-edit",
      component: EditReview,
      props: true,
      meta: { requiresAuth: true, requiredRoles: ["reviewer"], title: "심사 관리 > 심사하기" },
    },
  ],
};

export default reviewsMenu;
